module.exports = __webpack_public_path__ + "static/media/rich15.d74fde3a.JPG";